import styled from 'styled-components'
import { NotificationLevel } from './index'

const levelColors = {
  info: 'alertInfo',
  warning: 'alertWarning',
  risk: 'alertRisk',
  verified: 'alertVerified',
}

export const StyledBar = styled.div<{ level: NotificationLevel }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: ${({ level, theme }) => theme.colors[`${levelColors[level]}Bg`]};
  border-radius: 8px;
  padding: 16px 20px;
  width: 100%;
  color: ${({ level, theme }) => theme.colors[`${levelColors[level]}Text`]};
  transition: opacity 0.3s ease-in-out;

  ${({ theme }) => theme.media.sm`
    padding: 8px 12px;
  `}
`

export const StyledTitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;

  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
`

export const StyledLink = styled.a`
  color: #777a8c;
  font-size: 12px;
  font-weight: 500;

  cursor: pointer;
  :hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const StyledIcon = styled.img`
  width: 16px;
  height: 16px;
`

export const StyledCloseIcon = styled(StyledIcon)`
  cursor: pointer;
`

export const StyledWarningCheck = styled.label<{ level: NotificationLevel }>`
  display: flex;
  align-items: center;
  cursor: pointer;

  input[type='checkbox'] {
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  input:checked ~ .checkmark {
    background-color: ${({ level, theme }) =>
      theme.colors[`${levelColors[level]}Text`]};
  }

  .checkmark {
    width: 18px;
    height: 18px;
    position: relative;
    background: #fafbfc;
    border: 1px solid #eaecf5;
    border-radius: 4px;

    &::after {
      content: '';
      position: absolute;
      left: 5px;
      top: 2px;
      display: block;
      width: 5.7px;
      height: 10.5px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
`
